<template lang="pug">
div(
    class="relative"
    :style="containerStyle"
)
    Borderless(
        v-if="video"
        :video="video"
    )

    //- Shade for storyblok editor to prevent clicks
    div(
        v-if="$storyblok.isEditing"
        class="absolute inset-0 z-50"
    )
</template>

<script>
import Borderless from '@/integrations/wistia/borderless'

export default {
    name: 'VideoBannerWidget',
    components: {
        Borderless,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        video() {
            // TODO: It's kinda dumb borderless requires a video obj, yet only uses an id
            if (!this.data.mobileId || !this.data.desktopId) return false
            const id = this.$device.isMobile ? this.data.mobileId : this.data.desktopId
            return {
                id,
            }
        },
        containerStyle() {
            const style = {
                aspectRatio: '768/465',
            }
            if (!this.$device.isMobile)
                style.aspectRatio = this.data.desktopSize === 'BANNER' ? '1920/450' : '1920/600'

            return style
        },
    },
}
</script>
